import type { AuthUser } from 'src/auth/context/auth-context-value';

import { useAuthContext } from 'src/auth/hooks';

/**
 * 로그인한 사용자. **소비처가 49곳이라 여기서 좁히면 그 전부가 막힌다.**
 *
 * 모양은 `auth/context/auth-context-value.ts` 의 `AuthUser` 가 갖는다 —
 * 선언되지 않은 필드는 인덱스 시그니처를 타 `unknown` 이 된다. 여기서 새로 만들지 않는다.
 */
export function useUser(): AuthUser | null | undefined {
  const { user } = useAuthContext();
  return user;
}
